import { BreakPoints } from '@picsart/rc/enums';
import useWindowSize from '../useWindowSize/index.js';

var useMobileView = function useMobileView() {
  var width = useWindowSize().width;
  var isMobile = width <= BreakPoints.Small;
  return {
    isMobile: isMobile
  };
};

export { useMobileView as default };
//# sourceMappingURL=index.js.map
